export default __webpack_public_path__ + "static/media/ripple-loading.033c7f2d.svg";